import React, {useState, useEffect} from "react";
import { Link } from "react-router-dom";
import Navigation from "../partials/Navigation";
// import hviImg from "./../images/hvi-img.jpg";
import hviCoverImg from "./../images/hvi-cover-img.jpg";
import Slider from 'react-rangeslider';
import 'react-rangeslider/lib/index.css';
import hviQuestions from "../utils/hvi-questions";
import {Helmet} from "react-helmet";
import jwt_decode from "jwt-decode";
import { useCookies } from "react-cookie";
import configVars from "../config";
import { setWithExpiry, getWithExpiry } from '../common';
import HviMessages from "../partials/HVI/HviMessages";
import HorizontalNav from "../partials/Dashboard/HorizontalNav";
import Modal from 'react-bootstrap/Modal';
import HviPersonalSummary from "../partials/HVI/HviPersonalSummary";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const HallbarIndex = () => {

	const userHvi = useSelector((state) => state?.userdata?.allUserData?.hvi_data?.personal);
	const userMetaData = useSelector((state) => state?.userdata.allUserData?.user_meta);
	const hviLimit =useSelector((state) => state?.userdata?.allUserData?.hvi_data?.hvi_limit);

	const answeredHviCount = userHvi ? parseInt( userHvi.length, 10 ) : 0;
	const hviLimitNum = hviLimit ? parseInt( hviLimit, 10 ) : 1000;

	let intVal = [];

	if ( hviQuestions ) {
		hviQuestions.map( ( hviQuestion ) => 
			hviQuestion.type === 'custom' ? intVal.push({value: ''}) : intVal.push({value: 2})
		)
	}

	const [hviVal, setHviVal] = useState(intVal);
	const [currentStep, setCurrentStep] = useState(0);
	const [cookies] = useCookies(["sustainyou_user_jwt"]);
	const [saving, setSaving] = useState(false);
	const [hviCount, setHviCount] = useState(0);
	const [displayCount, setDisplayCount] = useState(false);
	const [modelShow, setModelShow] = useState(false);
	const [isNewHvi, setIsNewHvi] = useState(false);
	const [answeredCount, setAnsweredCount] = useState( answeredHviCount );

	const [translation] = useTranslation("translations");

	const hviLabels = {
		1: '1',
		2: '2',
		3: '3',
		4: '4',
		5: '5',
		6: '6'
	}

	useEffect(() => {

		const queryString = window.location.search;
    	const urlParams = new URLSearchParams(queryString);

		if (urlParams.get("count")) {

			const count = urlParams.get("count");

			if ( count.length > 0 ) {
				setHviCount(count);
				setDisplayCount(true);
			}

		} else {
			setHviCount(0);
			setDisplayCount(false);
		}

	}, []);

	const handleHviUpdate = (val, updatedIndex) => {

		const valInt = parseInt( val, 10 );

		const newHvi = hviVal.map( (obj, index ) => 
			index === updatedIndex ? { ...obj, value: valInt } : obj
		);

		setHviVal( newHvi );

	}

	const handleCompletedPercentage = ( current, total ) => {
		return ((current+1)/total)*100
	}

	const getHviColor = (count) => {
		let color = 'sy-red';

		if ( count > 24 && count < 60 ) {
			color = 'sy-yellow';
		}

		if ( count > 59 ) {
			color = 'dark-green';
		}

		return color;
	}

	const saveUserHvi = async () => {
		
		if ( ! cookies.sustainyou_user_jwt ) return;

		setSaving( true );

		const jwtDecoded = jwt_decode(cookies.sustainyou_user_jwt);

		const response = await fetch(
			`${configVars.apiUrl}sustainchange/v1/saveuserhvi/?userid=${jwtDecoded.id}&hvidata=${JSON.stringify(hviVal)}`,
			{
				method: "GET",
				headers: {
					Authorization: `Basic ${configVars.auth}`,
				},
			}
		);
		
		const hviResponse = await response.json();

		if ( hviResponse ) {
			
			if ( hviResponse.success === true ) {

				if ( hviResponse.data.recent_hvi ) {
					
					setWithExpiry( `sy_${jwtDecoded.id}_recent_hvi`, hviResponse.data.recent_hvi );

					setHviCount( hviResponse.data.recent_hvi.hvi_count );

					setDisplayCount(true);
					localStorage.removeItem('user_data_expire');

					setIsNewHvi(true);

					setAnsweredCount( answeredCount + 1);

				}

				if ( hviResponse.data.all_hvi ) {
					setWithExpiry( `sy_${jwtDecoded.id}_all_hvi`, hviResponse.data.all_hvi );
				}

				
			}



		}

		setSaving( false );

	}

	return (
		<div className="main-wrapper">
			<Helmet>
				<title>{translation('hvi_title')}</title>
				<meta name="description" content="" />
			</Helmet>
			<Navigation />

			<div className="page-content-wrap">
				<HorizontalNav title={translation("welcome")} />
				
				<div className="pt-5 pt-lg-0 page-content-inner">
					<div className="course-img-wrap d-flex overflow-hidden position-relative" style={{maxHeight: '300px',backgroundImage: `url(${hviCoverImg})`, backgroundSize: 'cover', backgroundPosition: 'center', height: '300px'}}>
						<div className="position-absolute w-100 h-100 top-0 left-0 dark-overlay d-flex justify-content-center align-items-center">
							<h1 className="text-white display-1 text-center text-shadow">{translation('hvi_title')}</h1>
						</div>
					</div>

						<div className="px-4" style={{maxWidth: '1400px'}}>
							<div className="hvi-wrap mt-5">

								{ displayCount &&
									<>
										<div className="display-count-wrap d-flex align-items-center">
											<h3 className="h1 fw-bold me-2">{translation('your_hvi_is')}:</h3>
											<span className={`hvi-count text-white text-center h2 mb-0 py-3 bg-${getHviColor(hviCount)}`} style={{width: '150px'}}>{hviCount}</span>
										</div>
										<div className="mt-5">
											<HviMessages count={hviCount} color={getHviColor(hviCount)} />
										</div>

										<HviPersonalSummary isNew={isNewHvi} userHvi={userHvi} hviLimit={hviLimitNum} answered={answeredHviCount}  />

										{ answeredCount < hviLimitNum &&
											<div className="my-5">
												<Link to="/hvi/" className="btn btn-halite-blue rounded-pill btn-lg px-5" onClick={ () => {setHviCount(0);setDisplayCount(false);}}>
													<i className="fa fa-life-ring" aria-hidden="true"></i>
													<span className="ms-3">{translation('go_to_test')}</span>
												</Link>
											</div>
										}

									</>
								}

								{ hviQuestions && !displayCount &&
									<>
										<div className="hvi-content mb-5">

											<div className="row">
												{/* <div className="col-12 col-lg-4">
													<img src={hviImg} alt="HVI" className="mw-100" />
												</div> */}
												<div className="col-12 col-lg-9">

													{ answeredCount >= hviLimitNum &&
														<div className="alert alert-secondary mb-4" role="alert">
															{translation('hvi_limit_msg')} <Link to="/plans/sustainyou-2/monthly" className="alert-link">{translation('link_to_page')}</Link>
														</div>
													}

													<div className="mb-4">
														<h4 className="fw-bold mb-3">Ta hjälp av vårt test Human Well-being Index, som hjälper dig att må bra och prestera hållbart.</h4>
														<p>På tolv frågor och cirka fem minuter kan du få en indikation på hur hållbar din vardag är. Frågorna är formulerade för att ge dig en sammantagen bild av hur du ligger till, och möjlighet att reflektera över vad som kan göra din vardag mer hållbar. Över tid kan du sedan följa hur du lyckas med att en mer hållbar livsstil och vardag.</p>
													</div>

													<div className="mb-4">
														<h4 className="fw-bold mb-3">Resultatet delas in i en röd-gul-grön skala enligt följande:</h4>
														<p><span className="bg-sy-red px-2 py-1 me-1 text-white rounded-2">Rött (12-24)</span>: Tyder på en ohållbar vardag och en riskfaktor för ohälsa – en riskposition. Du behöver göra något åt din situation för att inte riskera din hälsa.</p>
														<p><span className="bg-sy-yellow px-2 py-1 me-1 text-white rounded-2">Gult (25-59)</span>: Tyder på att delar av din vardag är ohållbar och att du pendlar mellan en risk- och friskposition. Genom att göra förändringar i din vardag kan du ta kommandot och göra tillvaron mer hållbar.</p>
														<p><span className="bg-dark-green px-2 py-1 me-1 text-white rounded-2">Grönt (60–72)</span>: Tyder på en hållbar vardag och är en friskfaktor för hälsa – en friskposition.</p>
														<p>Du kan känna dig trygg med att göra testet för dina svar behandlas helt konfidentiellt!</p>
													</div>

													{ answeredCount < hviLimitNum &&
														<div className="mb-4">
															<button type="button" className="btn btn-halite-blue rounded-pill btn-lg px-5" onClick={()=> setModelShow(true)}>
																<i className="fa fa-life-ring" aria-hidden="true"></i>
																<span className="ms-3">{translation('test_hvi_btn')}</span>
															</button>
														</div>
													}

													<Modal
														show={modelShow}
														onHide={() => setModelShow(false)}
														backdrop="static"
														keyboard={false}
														centered
														size="md"
													>
														<Modal.Header closeButton>
														<Modal.Title></Modal.Title>
														</Modal.Header>
														<Modal.Body className="hvi-model">
															<div className="toast show mb-5" role="alert" aria-live="assertive" aria-atomic="true">
															<div className="toast-header">
																<strong className="me-auto">{translation('hvi_test_title')}</strong>
																<small className="text-muted">{currentStep+1}/{hviQuestions.length}</small>
															</div>
															<div className="progress rounded-0" style={{height: '7px'}}>
																<div className="progress-bar progress-bar-striped progress-bar-animated bg-sea-green rounded-0" role="progressbar" aria-valuenow={handleCompletedPercentage(currentStep, hviQuestions.length)} aria-valuemin="0" aria-valuemax="100" style={{width: `${handleCompletedPercentage(currentStep, hviQuestions.length)}%`}}></div>
															</div>
															<div className="toast-body">
																<div className="hvi-single pb-4 mt-2">
																	<label >
																		<span className="fw-bold pe-2">{currentStep+1})</span>
																		<span>{hviQuestions[currentStep].title}</span>
																	</label>
																	{hviQuestions[currentStep].hints &&
																		<>
																			{hviQuestions[currentStep].hints.map( (hint, index) => {
																				return (
																					<div className="form-text ps-2" key={index}>{hint}</div>
																				)
																			})}
																			
																		</>
									
																	}
																	{hviQuestions[currentStep].type === 'numbers' &&
																		<Slider
																			value={hviVal[currentStep].value}
																			onChange={(value) => handleHviUpdate(value, currentStep)}
																			min={1}
																			max={6}
																			labels={hviLabels}
																		/>
																	}

																	{hviQuestions[currentStep].type === 'custom' && hviQuestions[currentStep].choices?.length > 0 &&
																		<div className="hvi-choices-wrap mt-3">
																			{ hviQuestions[currentStep].choices.map( (choice, index) => {

																				let stepSelectedVal;

																				if ( hviVal[currentStep].value == null || hviVal[currentStep].value === '' ) {
																					const savedStepVal = getWithExpiry(`user_meta_${hviQuestions[currentStep]?.key}`);

																					if ( savedStepVal != null ) {
																						stepSelectedVal = savedStepVal;
																					} else {
																						if ( userMetaData ) {
																							stepSelectedVal = userMetaData[hviQuestions[currentStep]?.key];
																						}
																					}
																				}

																				return (
																					<div className={`form-check ${hviQuestions[currentStep].display === 'inline' ? 'form-check-inline' : '' }`} key={index}>
																						<input 
																							className="form-check-input"
																							type="radio"
																							id={`${hviQuestions[currentStep].name}_${index}`} 
																							name={hviQuestions[currentStep].name} 
																							value={index}
																							checked={ stepSelectedVal !== '' && Number(stepSelectedVal) === index }
																							onChange={ (event) => { handleHviUpdate(event.target.value, currentStep) } }
																						/>
																						<label className="form-check-label" htmlFor={`${hviQuestions[currentStep].name}_${index}`}>{choice}</label>
																					</div>
																				)
																			}) }
																		</div>
																	}
																</div>
																<div className="mt-3 pt-3 border-top d-inline-block w-100">
																	{currentStep > 0 &&
																		<button type="button" className="btn btn-primary btn-sm text-white pe-4 ps-3" onClick={() => setCurrentStep(currentStep-1)}>
																			<i className="fa fa-angle-left" aria-hidden="true"></i>
																			<span className="ps-3">{translation('back')}</span>
																		</button>
																	}
																	{ (currentStep+1) < hviQuestions.length &&
																		<button type="button" className="btn btn-primary btn-sm float-end text-white ps-4 pe-3" onClick={() => setCurrentStep(currentStep+1)}>
																			<span className="pe-3">{translation('next')}</span>
																			<i className="fa fa-angle-right" aria-hidden="true"></i>
																		</button>
																	}
																	{ (currentStep+1) === hviQuestions.length &&
																		<button type="button" className="btn btn-sea-green btn-sm float-end text-white px-3" onClick={ () => saveUserHvi() }>
																			<span>{translation('save_and_close')}</span>
																			{saving &&
																				<div className="spinner-border text-light spinner-border-sm ms-2" role="status" >
																					<span className="visually-hidden">Loading...</span>
																				</div>
																			}
																		</button>
																	}
													
																</div>
															</div>
														</div>
														</Modal.Body>
													</Modal>

													

												</div>
											</div>

											{/* <div className="mb-4 mt-4 text-center">
												<h3 className="fw-bold">Hur är testet framtaget?</h3>
												<p>Frågorna är formulerade utifrån utmaningar i vår samtid – stress, sömn, återhämtning, gränsen mellan arbete och fritid – plus två klassiska modeller, KASAM samt Karasek och Theorells krav-kontroll-stöd-modell.</p>
											</div> */}

											
										</div>
										
									</>
								}
							</div>
						</div>
				</div>

			</div>
		</div>
	);
};

export default HallbarIndex;
